module.exports = __webpack_public_path__ + "fonts/fa-solid-900.5b08d3a.eot";